import singleProductPage from 'components/woocommerce/single-product/index';
import blockCategories from 'components/flexible-contents/block-categories/index';
import blockProducts from 'components/flexible-contents/block-products/index';
import blockTextColumn from 'components/flexible-contents/block-text-column/index';
import blockImageText from 'components/flexible-contents/block-image-text/index';
import blockGridCardsIcons from 'components/flexible-contents/block-grid-cards-icons/index';
import blockShortcode from 'components/flexible-contents/block-shortcode/index';


singleProductPage();
blockCategories();
blockProducts();
blockTextColumn();
blockImageText();
blockGridCardsIcons();
blockShortcode();